import { type AxiosError } from 'axios'
import {
  type QueryFunctionContext,
  useQuery,
  type UseQueryOptions
} from 'react-query'

import { fetchQueryData } from 'hooks/use-gremlin-query'
import {
  getEndpointWithParams,
  validateQueryDependencies
} from 'queries/queries-utils'
import { reliabilityTestsQueryKeys } from 'queries/reliability-tests/query-keys'
import { type ScenarioPreview } from 'types/api/reliability-tests/preview'

import type { ReliabilityTestsPreviewQueryParams } from 'queries/reliability-tests/types'

function fetchReliabilityTestPreview({
  queryKey: [baseUrl, params]
}: QueryFunctionContext<
  ReturnType<typeof reliabilityTestsQueryKeys.getPreview>
>) {
  validateQueryDependencies(
    params,
    'in order to fetch reliability test preview'
  )
  const endpointWithParams = getEndpointWithParams(baseUrl, params)
  return fetchQueryData<ScenarioPreview>(endpointWithParams)
}

export function useGetReliabilityTestPreview(
  params?: ReliabilityTestsPreviewQueryParams,
  queryOptions?: Omit<
    UseQueryOptions<ScenarioPreview, AxiosError>,
    'queryKey' | 'queryFn'
  >
) {
  return useQuery({
    ...queryOptions,
    queryFn: fetchReliabilityTestPreview,
    ...(params && {
      queryKey: reliabilityTestsQueryKeys.getPreview(params)
    })
  })
}
